import instance from "./config";
import page from "../services/pages.js";

interface ICustomerCreatePayload {
  customer_form: {
    name: string;
    username: string;
    email: string;
    password_one: string;
    password_two: string;
    phonenumber: string;
  };
  payment_method_form: {
    name: string;
    cc_number: string;
    exp_month: number;
    exp_year: number;
    cvc: number;
  };
}

export default {
  create: async function (
    payload: ICustomerCreatePayload,
    jwt: string
  ): Promise<any> {
    try {
      const { data } = await instance.post("/customers/create", payload, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  },
  listAll: async function (jwt, onlyInactive = true) {
    try {
      const response = await instance.get(
        `/customers?is_active=${onlyInactive}`,
        {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  get: async function (jwt, id) {
    try {
      const response = await instance.get(`/customers/${id}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getUsersRights: async function (
    jwt,
    {
      search = "",
      role = "",
      project_id = "",
      is_active = "",
      team_id = "",
      board_id = "",
      customer_id = "",
      company_id = "",
      username = "",
    }
  ) {
    try {
      const searchParams = page.makeListServiceQueryParams({
        search,
        role,
        project_id,
        is_active,
        team_id,
        board_id,
        customer_id,
        company_id,
        username,
      });
      const response = await instance.get(
        `/customers/user-rights?${searchParams.toString()}`,
        {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );

      const { data } = response;

      const users = data.data.map((user, index) => {
        return {
          index: index + 1,
          company_name: user.company_name,
          id: user.id,
          name: user.name,
          username: user.username,
          email: user.email,
          role: user.role,
          is_active: user.is_active,
          project_id: user.project_id,
          team_id: user.team_id,
          board_id: user.board_id,
          customer_id: user.customer_id,
          company_id: user.company_id,
        };
      });
      return users;
    } catch (error) {
      throw error;
    }
  },

  updateUserRights: async function (jwt, payload) {
    try {
      const response = await instance.post(`/customers/user-rights`, payload, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  getMe: async function (jwt: string): Promise<any> {
    try {
      const { data } = await instance.get("/customers/me", {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return data.data;
    } catch (error) {
      return null;
    }
  },
  updateById: async function (jwt, payload, id) {
    try {
      const response = await instance.put(`/customers/${id}`, payload, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  update: async function (jwt, payload) {
    try {
      const response = await instance.put(`/customers`, payload, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  resetPassword: async function (jwt, id) {
    try {
      const response = await instance.post(
        `/customers/${id}/password-reset`,
        {},
        {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  disabled: async function (jwt, id, payload) {
    try {
      const response = await instance.put(`/customers/${id}`, payload, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async function (jwt, id) {
    try {
      const response = await instance.delete(`/customers/${id}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
